import React from 'react';
import ReactDOM from 'react-dom';
import { GlobalStyle } from '@moonpig/launchpad-components';
import { theme } from '@moonpig/launchpad-theme';
import { ThemeProvider } from '@moonpig/launchpad-utils';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle/>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
